export default {
  //Search
  "zoek": "zoek",
  "Waar ben je naar op zoek?": "Waar ben je naar op zoek?",
  "vanaf": "vanaf",
  "Meer resultaten voor {inputQuery}": "Meer resultaten voor {inputQuery}",
  "Geen resultaten gevonden voor {inputQuery}": "Geen resultaten gevonden voor {inputQuery}",

  //Category page
  "Er zijn geen producten gevonden": "Er zijn geen producten gevonden",
  "Filter binnen {totalProductCount} producten": "Filter binnen {totalProductCount} producten",
  "Sluiten": "Sluiten",
  "Prijs": "Prijs",
  "Vul een geldige waarde in": "Vul een geldige waarde in",
  "Actieve filters:": "Actieve filters:",
  "Filteren": "Filteren",
  "{fromProducts} tot {toProducts} van {totalProductCount} resultaten": "Geen resultaten | 1 resultaat | {fromProducts} tot {toProducts} van {totalProductCount} resultaten",
  "Sorteren op": "Sorteren op",
  "Naam (A-Z)": "Naam (A-Z)",
  "Naam (Z-A)": "Naam (Z-A)",
  "Prijs (Oplopend)": "Prijs (Oplopend)",
  "Prijs (Aflopend)": "Prijs (Aflopend)",

  //Product page
  "Vloeren zijn alleen per pak te bestellen.": "Floors can only be ordered per pack.",
  "Vloeren zijn alleen per pak te bestellen, kies een andere maat.": "Floors can only be ordered per pack, choose another size.",
  "Vandaag besteld, morgen in huis": "Vandaag besteld, morgen in huis",
  "Selecteer één van de verplichte opties.": "Selecteer één van de verplichte opties.",
  "In winkelmand": "In winkelmand",
  "Bewaren": "Bewaren",
  "Op voorraad in:": "Op voorraad in:",
  "Gratis bezorging": "Gratis bezorging",
  "Artikelnr": "Artikelnr",
  "Selecteer je {option}": "Selecteer je {option}",
  "Er zijn voor dit product geen beschikbare opties gevonden.": "Er zijn voor dit product geen beschikbare opties gevonden.",
  "Kies een selectie...": "Kies een selectie...",
  "Niet op voorraad": "Niet op voorraad",
  "Zoek op postcode": "Zoek op postcode",
  "Business order": "Business order?",
  "VAT Number": "VAT Number",
  "Chamber of Commerce number": "Chamber of Commerce number",
  "Sign up for the newsletter": "Sign up for the newsletter",
  "We have found the following address": "We have found the following address",
  "Invalid address. Are you sure it is correct?": "Invalid address. Are you sure it is correct?",
  "Click here to enter the address manually.": "Click here to enter the address manually.",
  "Click here to automatically retrieve your address": "Click here to automatically retrieve your address",
  "Home delivery": "Home delivery",
  "Pick up at a PostNL point": "Pick up at a PostNL point",
  "Choose a pickup point": "Choose a pickup point",
  "Please choose a pickup point.": "Please choose a pickup point to continue.",
  "Please choose a delivery date.": "Please choose a delivery date to continue.",
  "Ready for pickup from": "Ready for pickup from",
  "No pickup points found for this address.": "No pickup points found for this address.",
  "You can pick up your order at": "You can pick up your order at",
  "Change pickup point": "Change pickup point",
  "Enter a valid postcode and house number first so we can show the delivery options.": "Enter a valid postcode and house number first so we can show the delivery options.",
  "Delivery options could not be loaded. Please check your address and try again.": "Delivery options could not be loaded. Please check your address and try again.",
  "Order comments": "Order comments",
  "Comments on your order": "Comments on your order",
  "Any comments about your order?": "Any comments about your order?",
  "The VAT number is valid.": "The VAT number is valid.",
  "The VAT number is invalid.": "The VAT number is invalid.",
  "The VAT number could not be validated at this time.": "The VAT number could not be validated at this time.",
  "Please enter a valid VAT number, including the country code (e.g. NL123456789B01).": "Please enter a valid VAT number, including the country code (e.g. NL123456789B01).",

  //Product siblings
  "Color": "Color",
  "Finish": "Finish",
  "{name} (out of stock)": "{name} (out of stock)",
}
